import { Spinner } from "react-bootstrap";

const ESpinner = () => {
    return (
        <div className="text-center">
            <Spinner animation="border" variant="primary" />
        </div>
    )
}
 
export default ESpinner;